import React, { useEffect } from "react";
import { Box, Avatar, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import io from "socket.io-client";
import Key from "../../clientVariables.json";
import { userSelector } from "../user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { userActivity } from "../user-redux/action";

// const socket = io(`${Key.domain}`); // Connect to Socket.IO server

const UserAvatar = ({ user, handleOpenUserMenu }) => {
  const userId = user?.id;
  const dispatch = useDispatch();
  const { userIsIdle } = useSelector(userSelector);

  // useEffect(() => {
  //   getUserLastSeen();
  //   const intervalId = setInterval(getUserLastSeen, 20000); // Fetch every 20 seconds
  //   return () => clearInterval(intervalId);
  // }, [user]);

  // const getUserLastSeen = () => {
  //   dispatch(userActivity(user));
  // };

  // useEffect(() => {
  //   let idleTimer;

  //   const resetIdleTimer = () => {
  //     clearTimeout(idleTimer);
  //     socket.on("connect", () => {
  //       console.log("Connected to Socket.IO server");
  //     });
  //     socket.emit("user_activity", { user_id: userId, is_active: true });

  //     idleTimer = setTimeout(() => {
  //       socket.emit("user_activity", { user_id: userId, is_active: false });
  //     }, (1 * 60 * 1000) / 2); // 30 seconds
  //   };

  //   window.addEventListener("mousemove", resetIdleTimer);
  //   window.addEventListener("keydown", resetIdleTimer);

  //   resetIdleTimer(); // Start the timer initially

  //   return () => {
  //     clearTimeout(idleTimer);
  //     window.removeEventListener("mousemove", resetIdleTimer);
  //     window.removeEventListener("keydown", resetIdleTimer);
  //   };
  // }, [userId]);

  return (
    <Box display="flex" alignItems="center">
      <Box position="relative">
        <Avatar
          key={user?._imageTs || user?.image}
          alt={user?.full_name || "User Avatar"}
          src={`${Key.aws_bucket_profile}/attachments/user_${user?.id}/profileimages/${user?.image}${user?._imageTs ? `?v=${user._imageTs}` : ""}`}
          sx={{ border: "2px solid white", width: 40, height: 40 }}
        />
        {/* Status Indicator */}
        {/* <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: userIsIdle ? "green" : "orange",
            border: "2px solid white",
          }}
        /> */}
      </Box>

      <Box ml={1} onClick={handleOpenUserMenu} sx={{ p: 0, cursor: "pointer" }}>
        <Typography variant="body2" style={{ color: "#000", fontWeight: 500 }}>
          <span style={{ fontWeight: "600" }}>{user?.full_name}</span>
          <br />
          <span style={{ fontSize: "12px", color: "#000" }}>
            {user?.username} <ArrowDropDownIcon />
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default UserAvatar;
